/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, KeyboardEvent } from "react";
import { useTranslation } from "react-i18next";

import { PAGE_NUMBER_OPTIONS } from "../../../config";
import { InputBox } from "../../FormElement/InputBox";
import ToggleBtns from "../../ToggleBtns";
import "../../FacilityListComponents/ListTopBar/styles.scss";

export interface IListTopBarProps {
  filterFormData: any;
  onChangeFilterFormData: (filterFormData: any) => void;
}

export const ListTopBar: React.FunctionComponent<IListTopBarProps> = (
  props
) => {
  const { t: _t } = useTranslation();
  const t = (key: string) =>
    _t(
      `organizationManagementPage.organizationManagementList.listTopBar.${key}`
    );

  const { filterFormData, onChangeFilterFormData } = props;

  const [searchName, setSearchName] = useState<string>(
    filterFormData?.searchName || ""
  );

  return (
    <div className="list-top-bar flex-grid">
      <div className="lefts"></div>
      <div className="rights flex">
        <div className="search-module">
          <div className="top-txt">&nbsp;</div>
          <InputBox
            value={searchName}
            placeholder={t("search_by_name")}
            isSearch={true}
            classNameContainer={"search-input"}
            onChange={(value: string) => {
              setSearchName(value);
            }}
            onKeyPress={(event: KeyboardEvent<HTMLInputElement>) => {
              if (event.key === "Enter") {
                onChangeFilterFormData({
                  ...filterFormData,
                  searchName: searchName,
                  pageIndex: 1,
                });
              }
            }}
          />
        </div>
        <div className="choose-area">
          <div className="top-txt">{t("number_of_facilities_per_page")}</div>
          <ToggleBtns
            selectedValue={filterFormData.numberPerPage}
            options={PAGE_NUMBER_OPTIONS}
            onClickBtn={(option: number) => {
              onChangeFilterFormData({
                ...filterFormData,
                numberPerPage: option,
                pageIndex: 1,
              });
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default ListTopBar;
